import React from "react";
import { of } from "rxjs";
import { IGlobal } from "config/config.interface";
import { IAppTranslations } from "lib/translations/interfaces/translations.interface";

export class UnsupportedLanguageModal {
    globalConfig = (global as any as IGlobal);
    message: any;
    continue: any;
    title: any = {
        value: ''
    };
    constructor(translations: IAppTranslations) {
        this.title = translations.assessment_modal_header_language_unavailable;
        this.continue = translations.common_continue;
        this.message = translations.assessment_modal_body_language_unavailable;
    }

    replaceTranslationPlaceholdersNoLanguage(translation: string, assessmentName: string) {
        const languageName = this.globalConfig.config.LANGUAGES.find(l => l.code === this.globalConfig.store.getState().user.participantLanguageCode);
        if (translation && languageName) {
            let updatedTranslation = translation;

            updatedTranslation = updatedTranslation.replace(/%ASSESSMENT%/g, assessmentName);
            updatedTranslation = updatedTranslation.replace(/%LANGUAGE%/g, languageName.name1);
            return (updatedTranslation);

        }
        return "";
    }

    build(assessmentName: string): any {
        const modalMessage = (
            <>
                {this.replaceTranslationPlaceholdersNoLanguage(this.message, assessmentName)}
            </>
        )

        return of({
            title: this.title ? this.title : '',
            message: modalMessage,
            size: 'md',
            buttons: {
                close: {
                    label: this.continue ? this.continue : '',
                    className: 'btn-primary mx-auto text-capitalize'
                }
            }
        });
    }
}